//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal',
                {
                    url: '/Portal',
                    component: 'portalComponent',
                    resolve: {
                        user: ["homeApi", function (homeApi) {
                            return homeApi.getUserInfo();
                        }],
                        userGroup: ["userGroupApi", "user", function (userGroupApi, user) {
                            if (user.UserGroupId)
                                return userGroupApi.get(user.UserGroupId);
                            return null;
                        }],
                        logo: ["userGroupApi", "user", "portalBaseApiUrl", function (userGroupApi, user, portalBaseApiUrl) {
                            if (user.UserGroupId) {
                                var logoUrl = portalBaseApiUrl + "/UserGroups/" + user.UserGroupId + "/Logo";
                                if (localStorage.getItem("UserGroupLogo") === null
                                    || localStorage.getItem("UserGroupLogo") !== logoUrl) {
                                    localStorage.setItem("UserGroupLogo", logoUrl);
                                    localStorage.setItem("UserGroupId", user.UserGroupId);
                                }
                                return logoUrl;
                            } else {
                                localStorage.removeItem("UserGroupLogo");
                                localStorage.removeItem("UserGroupId");
                            }
                            return null;
                        }],
                        delegates: ["userApi", "user", function (userApi, user) {
                            return userApi.getUsersForDelegateUser(user.Id);
                        }],
                        onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).catch(ng.noop);
                            return null;
                        }],
                        permissions: ["permissionApi", "permissionService", function (permissionApi, permissionService) {
                            return permissionApi.getPolicyStatements().then(function (response) {
                                permissionService.setPermissions(response);
                            });
                        }],
                        masterAdvisorAgreementRequiredRecord: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getMasterAdvisorAgreementRequiredRecord().then(function (model) {
                                if (model.data === "")
                                    return null;
                                return model;
                            });
                        }],
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                if (agreement.data === "")
                                    return null;
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        isContractingOnboardingNeeded: ["onboardingApi", function (onboardingApi) {
                            return onboardingApi.getContractingCompleted().then(function (response) {
                                return response;
                            });
                        }],
                        onBehalfOfUserGroup: ["userApi", "permissionService", "userGroupApi", function (userApi, permissionService, userGroupApi) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).then(function (user) {
                                    if (user.UserGroupId)
                                        return userGroupApi.get(user.UserGroupId);
                                    return null;
                                });
                            return null;
                        }],
                    },
                    redirectTo: function (trans) {
                        var resolvedUser = trans.injector().getAsync('user');
                        return resolvedUser.then(function (user) {
                            var permissionService = trans.injector().get('permissionService');
                            if (permissionService.emailDomainAllowed(user.Email)) {
                                // Bypass onboarding via email domain
                                return 'Portal.MyBusiness';
                            }
                            var env = trans.injector().get('featureToggleService').checkEnv();
                            var isOnboarding = trans.injector().get('$cookies').get('is-onboarding') == 'true' ? true : false;
                            var masterAdvisorAgreementRequiredRecord = trans.injector().getAsync('masterAdvisorAgreementRequiredRecord').then(function (result) { return result; });
                            var userMasterAdvisorAgreement = trans.injector().getAsync('userMasterAdvisorAgreement')
                                .then(function (result) {
                                    return result;
                                });
                            var isContractingOnboardingCompleted = trans.injector().getAsync('isContractingOnboardingNeeded')
                                .then(function (result) {
                                    return result;
                                });
                            var isAdvisorAgreementNeeded = masterAdvisorAgreementRequiredRecord != null
                                && userMasterAdvisorAgreement == null ? true : false;

                            // If MAA needs signing AND it's required for this user send them to first step of onboarding
                            if (isAdvisorAgreementNeeded) {
                                return 'Onboarding';
                            }

                            // If user has not completed SureLC contracting, send them to Carrier Setup
                            if (!isContractingOnboardingCompleted) {
                                return 'Onboarding.CarrierSetup';
                            }

                            // If user has completed required onboarding stages, but still have onboarding cookie, send them to training so they see all onboarding stages
                            if (isOnboarding) {
                                return 'Onboarding.Training';
                            }

                            if (env !== 'prod') {
                                return 'Portal.MyBusiness';
                            } else {
                                return 'Home';
                            }
                        });
                    }
                });
        }
    ]);

    app.component('portalComponent', {
        templateUrl: 'App.Portal/Portal.template.html',
        controller: 'PortalController',
        bindings: {
            user: "<",
            userGroup: "<",
            logo: "<",
            delegates: "<",
            onBehalfOfUser: "<",
            masterAdvisorAgreementRequiredRecord: "<",
            masterAdvisorAgreements: "<",
            userMasterAdvisorAgreement: "<",
            isContractingOnboardingCompleted: "<"
        }
    });

    app.controller('PortalController', PortalController);

    PortalController.$inject = ['_', 'amplitudeService', 'AuthService', 'externalLoading', 'figToaster', 'homeApi', 'iComplyApi', 'iComplySettings', '$mdDialog', '$mdSidenav', 'permissionService', 'pointAdjustmentApi', 'ssoApi', '$state', 'permissionApi', '$timeout', 'userApi'];

    function PortalController(_, amplitudeService, AuthService, externalLoading, figToaster, homeApi, iComplyApi, iComplySettings, $mdDialog, $mdSidenav, permissionService, pointAdjustmentApi, ssoApi, $state, permissionApi, $timeout, userApi) {
        var $ctrl = this;

        $ctrl.hasSubmitMarketingExpensesPermissions = (permissionService.hasOnePermission("AccessMarketingPoints:View") && permissionService.hasOnePermission("PointAdjustments:View")) ? true : false;

        $ctrl.nav = [
            {
                name: 'Business',
                url: 'Portal.MyBusiness',
                icon: 'fig-briefcase-filled',
                //subnav: [
                //    {
                //        name: 'Policy List',
                //        url: 'Portal.MyBusiness.PolicyList',
                //        icon: 'fig-account-card-multiple',
                //    }
                //    //TODO: Remove when policy linked to policy list
                //    //,{
                //    //    name: 'Policy Details',
                //    //    url: 'Portal.MyBusiness.PolicyDetails({policyGuid: "bbad521b-1061-497a-9ee8-b110293d7b8c"})',
                //    //    icon: 'fig-account-card-details',
                //    //},
                //    //END TODO
                //],
            },
            {
                name: 'Carriers & Training',
                url: 'Portal.CarriersTraining',
                icon: 'fig-school-filled',
                ShowIfAll: "SureLc:Access",
            },
            {
                name: 'FIG Platform',
                url: 'Portal.FigPlatform',
                icon: 'fig-building-blocks-filled',
            },
            {
                name: 'Toolbox',
                url: 'Portal.Toolbox',
                icon: 'fig-toolbox-filled',
            },
            // TODO: when Simon is ready for iframe uncomment this:
            /*{
                name: 'Simon',
                url: 'Portal.Simon',
                icon: 'fig-web',
                ShowIfAll: "Simon:View",
            },*/
            {
                name: 'Return to Portal',
                url: 'Home',
                icon: 'fig-arrow-left',
            }
        ];

        //filter nav permissions as needed 
        $ctrl.nav = _.filter($ctrl.nav,
            function (row) {
                var show = true; //default show all nav items
                if (row.ShowIfAll) {
                    show = permissionService.hasAllPermissions(row.ShowIfAll);
                }
                if (row.HideIfOne)
                    if (permissionService.hasOnePermission(row.HideIfOne, true))
                        show = false;
                return show;
            });


        $ctrl.logout = function () {
            AuthService.logout();
        };

        $ctrl.activateFirelightSso = function () {
            if (permissionService.hasOnePermission("Firelight:Access")) {
                //console.log(this.SamlData);
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateFirelightSso(this.SamlData).then(function (data) {
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        $ctrl.activateIpipelineSso = function () {
            if (permissionService.hasOnePermission("IpipelineEApps:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateIpipelineEappsSso().then(function (data) {
                    //console.log(data);
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        $ctrl.logCustomNavEvent = function (evt) {
            return amplitudeService.logCustomEvent('Main Nav Click', evt, {});
        };


        $ctrl.redeemMarketingDollars = function ($event) {
            $ctrl.logCustomNavEvent('Redeem Marketing Dollar');
            $mdDialog
                .show({
                    targetEvent: $event,
                    controller: "RedeemMarketingDollars2Controller",
                    controllerAs: "$ctrl",
                    templateUrl: "/App.Portal/Modals/RedeemMarketingDollars/RedeemMarketingDollars.template.html",
                    bindToController: true,
                    marketingDollars: $ctrl.marketingDollars,
                    user: $ctrl.user,
                    onBehalfOfUser: $ctrl.onBehalfOfUser,
                    marketingConsultant: $ctrl.marketingConsultant
                })
                .then(function () {
                    _getAgentMarketingDollars();
                });
        };

        $ctrl.viewLeaderboard = function ($event) {
            var data = null;

            $ctrl.logCustomNavEvent('View Leaderboard');

            $mdDialog.show({
                targetEvent: $event,
                controller: "Leaderboard2Controller",
                controllerAs: "$ctrl",
                templateUrl: "/App.Portal/Modals/Leaderboard/Leaderboard.template.html",
                bindToController: true,
                resolve: {
                    data: [
                        "leaderboardApi", function (leaderboardApi) {
                            if (data === null) return leaderboardApi.get();
                            return data;
                        }
                    ]
                }
            });
        };

        $ctrl.openSupportModal = function ($event) {
            $ctrl.logCustomNavEvent('Open Support');

            $mdDialog.show({
                targetEvent: $event,
                controller: "Support2Controller",
                controllerAs: "$ctrl",
                templateUrl: "/App.Portal/Modals/Support/Support.template.html",
                bindToController: true,
                resolve: {
                    userInfo: ["homeApi", function (homeApi) {
                        return homeApi.getUserInfo().then(function (userModel) {
                            return userModel;
                        });
                    }]
                }
            });
        }

        $ctrl.openPaperApplicationModal = function (event) {
            $mdDialog.show({
                targetEvent: event,
                controller: "SubmitPaperApplicationController",
                controllerAs: "$ctrl",
                templateUrl: "/App.Portal/Modals/SubmitPaperApplication/SubmitPaperApplication.template.html",
                bindToController: true,
                resolve: {
                    //products: ["arcBusinessApi", function (arcBusinessApi) {
                    //    // call to get product list from arc
                    //    return arcBusinessApi.getArcProducts().then(function (response) {
                    //        console.log('resolve',response);
                    //        return response.Products;
                    //    });
                    //}]
                }
            });
        };

        $ctrl.redirectToIcomplyLite = function () {
            var w = window;
            $ctrl.logCustomNavEvent('iComply Lite');

            iComplyApi.getFastTrackToken().then(function (result) {
                w.document.write(externalLoading.html);
                var auth = JSON.parse(result.Auth);
                var url = iComplySettings.baseUrl +
                    "/Sso?accesstoken=" + auth.Token +
                    "&expiration=" + auth.Expiration +
                    "&fasttrack=true";

                if (result.OnBehalfOfUserFigAuthId !== null) {
                    url += "&onbehalfofauthuserid=" + result.OnBehalfOfUserFigAuthId;
                }

                w.location.href = url;
            },
                function error(x) {
                    console.log(x.data);
                    //w.document.write("SSO Failed.  There was an error accessing this resource.");
                    $ctrl.ssoError = true;
                    //$state.go("Home.Tools.EApps", {}, { reload: true });
                    //w.location.href = "/OldPortal/#/Tools/EApps";

                    $timeout(function () {
                        $state.go("Home.Tools.Applications.EApps");
                    });
                });
        };

        $ctrl.selectOnBehalfOfUser = function (delegateId) {
            var delegate = $ctrl.delegates.find(function (row) { return row.Id === delegateId; });
            if (delegate) {
                $ctrl.delegateId = delegateId;
                permissionService.setOnBehalfOfUserId(delegate.OnBehalfOfUserId);
                permissionService.setUserDelegateId(delegate.Id);
                return permissionApi.getDelegatePermissions(delegate.Id).then(function (permissions) {
                    permissionService.setPermissions(permissions);
                    $state.go("Portal", {}, { reload: true });
                });
            }
        };

        $ctrl.selectMeAsUser = function () {
            $ctrl.delegateId = null;
            userApi.getLoggedInUserPermissions().then(function (permissions) {
                permissionService.removeStoredOnBehalfOfUserId();
                permissionService.setPermissions(permissions);
                $state.go("Portal", {}, { reload: true });
            });
        };

        $ctrl.toggleNav = function (navId) {
            $mdSidenav(navId).toggle();
        };

        function getAgentMarketingDollars() {
            return homeApi.getUserMarketingDollars().then(function (dollars) {
                $ctrl.marketingDollars = dollars;
                return dollars;
            }, function () {
                $ctrl.marketingDollars = 0;
                return 0;
            });
        }

        $ctrl.$onInit = function () {
            $ctrl.delegateId = permissionService.getUserDelegateId();
            getAgentMarketingDollars();
            pointAdjustmentApi.getMarketingConsultant()
                .then(function (response) {
                    $ctrl.marketingConsultant = response;
                    $ctrl.hasMarketingConsultant = true;
                })
                .catch(function () {
                    $ctrl.hasMarketingConsultant = false;
                });
        };
    }
})(window.angular, window.app);